import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconHeartFilled = createSVG({
    children: (jsx("path", { d: "M10.236 3.981q-.874-.64-1.748-.895a4.35 4.35 0 0 0-1.75-.148 4.5 4.5 0 0 0-1.619.49 6 6 0 0 0-1.513 1.15 5.4 5.4 0 0 0-1.45 2.6q-.34 1.491.063 2.856.32 1.407 1.237 2.876a24 24 0 0 0 2.13 2.855 35 35 0 0 0 2.622 2.643q1.285 1.171 2.643 2.259.512.426 1.151.426.64 0 1.151-.426a55 55 0 0 0 2.643-2.259 33 33 0 0 0 2.601-2.643 23 23 0 0 0 2.153-2.855q.916-1.47 1.236-2.876.405-1.365.043-2.856a5.23 5.23 0 0 0-1.428-2.6 6 6 0 0 0-1.514-1.15 4.6 4.6 0 0 0-1.64-.49 4.3 4.3 0 0 0-1.727.149q-.874.256-1.748.895l-1.13.959a.96.96 0 0 1-.639.233.96.96 0 0 1-.64-.234l-1.13-.959z" })),
});

export { IconHeartFilled };
